import {actionTypes} from '../const';
const pagination = (state = [], action) => {
    
    switch (action.type) {
        case actionTypes.PAGINATION_SUCCESS: 
            var paginationState = {
                key_for_next : action.paginationObj.key_for_next,
                key_for_prev : action.paginationObj.key_for_prev,
                pageNum : '',
                last_to_prev_key : action.paginationObj.last_to_prev_key,
                ext_first_key : action.paginationObj.ext_first_key,
                disableFirst:action.paginationObj.disableFirst,
                disableLast:action.paginationObj.disableLast
            }
            return Object.assign({}, state, {
                paginationState : paginationState
            });
        default:
            return state;
    }
}
export default pagination